import { Component } from '@angular/core';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrl: './website-footer.component.scss'
})
export class WebsiteFooterComponent {
  currentYear = new Date().getFullYear();
}
